import Settings from "components/Conversations/Settings";
import LogoutModal from "./LogoutModal";
import { useState } from "react";
import Div100vh from "react-div-100vh";

function SettingsMenu({ showSettings, setShowSettings }) {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  return (
    <Div100vh>
      {showLogoutModal && (
        <LogoutModal
          setShowLogoutModal={setShowLogoutModal}
          showLogoutModal={showLogoutModal}
        />
      )}

      {!!showSettings && <div className="conv__settings__overlay"></div>}
      {!!showSettings && (
        <div
          className={`conv__settings ${
            showSettings ? "open_settings" : "close_settings"
          }`}
        >
          <Settings
            toggleSettings={() => setShowSettings((prev) => !prev)}
            handleCloseSettings={() => setShowSettings(false)}
            setShowLogoutModal={setShowLogoutModal}
          />
        </div>
      )}
    </Div100vh>
  );
}

export default SettingsMenu;
